import type { Dispatch, AnyAction } from 'redux';

import * as ShouldRoundUnassignedEntriesAPI from 'ab-api/web/timeCard/shouldRoundUnassignedEntries';
import * as TimeCardUnassignedEntriesAPI from 'ab-api/web/workOrderReport/bulkAssignWorkOrdersToEntry';
import * as TimeCardDeleteUnassignedEntriesAPI from 'ab-api/web/workOrderReport/deleteUnassignEntries';
import * as FetchAccountTimeCard from 'ab-api/web/workOrderReport/fetchAccountTimeCard';
import type { W_WorkOrderReport_TimeCardEntry_VM } from 'ab-api/web/workOrderReport/fetchAccountTimeCard/viewModel';
import * as FindRejectedEntriesForAccount from 'ab-api/web/workOrderReport/findRejectedEntriesForAccount';
import type { W_WorkOrderReport_TimeCardRejectedTimeSheet_VM } from 'ab-api/web/workOrderReport/findRejectedEntriesForAccount/viewModel';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

interface BulkAssignWorkOrderToWntries {
	/** finalWoEntryPairs: { entryId : workOrderId } */
	finalWoEntryPairs: { [entryId: number]: number; };
}

export function bulkAssignWorkOrderToEntries(data: BulkAssignWorkOrderToWntries, accountId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.post<void>(TimeCardUnassignedEntriesAPI.URL(accountId), data);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

interface UnassignedEntriesIds {
	unassignedEntriesId: number[];
	accountId: number;
}

export function deleteTimeSheetEntries(data: UnassignedEntriesIds) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			const { unassignedEntriesId, accountId } = data;
			return await http.delete<void>(TimeCardDeleteUnassignedEntriesAPI.URL(), { unassignedEntriesId, accountId });
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function fetchAccountTimeCard(accountId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<W_WorkOrderReport_TimeCardEntry_VM[]>(FetchAccountTimeCard.URL(accountId));
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findRejectedTimeSheets(accountId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<W_WorkOrderReport_TimeCardRejectedTimeSheet_VM[]>(FindRejectedEntriesForAccount.URL(accountId));
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function shouldRoundUnassignedEntries() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<boolean>(ShouldRoundUnassignedEntriesAPI.ROUTE);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}
